<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box"  v-if="screenWidth>785">
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<div class="top_gatebox">
						<div class="manage_switch" v-if="screenWidth>785">
							<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
							  <el-option
							    v-for="item in manageoptions"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								>
							  </el-option>
							</el-select>
						</div>
					</div>
					<div class="top_search_box" v-if="screenWidth>785" >
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								
								>
							  </el-option>
							</el-select>
							<!-- <i class="el-icon-search"></i> -->
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
						</div>
						  
					</div>
					<div class="top_right">
						<div class="top_Mobiletype" @click="goregister()">
							账号注册/绑定
						</div>
						<div class=""  v-if="token" >
							欢迎访问!
						</div>
						<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
							登出
						</div>
					</div>
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								课程详情
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#1b9d57"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
								<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		<!-- <div class="swim_box"  v-if="screenWidth>785">
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="coursedata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="acttop_box" :style="screenWidth>785?'':'width:100%; flex-direction: column;'">
					<div class="acttop_imgs" :style="screenWidth>375?'':'padding:10px 0px;'">
						
						    <el-carousel :height="screenWidth>375?'210px':(screenWidth*210/375)+'px'">
						      <el-carousel-item v-for="item in coursedata.lunbo" :key="item">
						        <h3 class="small"  style="height: 100%;position: relative;"><img :src="item" style="width: 100%;height: 100%;" alt="" srcset="">
								<img src="../../../static/img/已认证.png" alt="" style="width: 45px;height: 35px;position: absolute;top:0px;left: 0px;z-index: 999;">
								</h3>
						      </el-carousel-item>
						    </el-carousel>
					</div>
					<div class="acttop_msg" :style="screenWidth>785?'':'width:calc(100% - 40px);padding:10px;'">
						<el-descriptions class="margin-top" :title="coursedata.title" :column="1"  >
						    <el-descriptions-item   >
						      <template slot="label">
						        <!-- <i class="el-icon-user"></i> -->
						        作者
						      </template>
						      {{coursedata.author}}
						    </el-descriptions-item>
						    <el-descriptions-item >
						      <template slot="label">
						        <!-- <i class="el-icon-mobile-phone"></i> -->
						        作者单位
						      </template>
						      {{coursedata.company}}
						    </el-descriptions-item>
							<el-descriptions-item >
							  <template slot="label">
							    课程时长
							  </template>
							  {{coursedata.research_class}}课时
							</el-descriptions-item>
							<el-descriptions-item >
							  <template slot="label">
							    总浏览量
							  </template>
							  <span style="color: #1b9d57;">{{coursedata.uv}}</span>
							</el-descriptions-item>
							<el-descriptions-item v-if="coursedata.theme.title" >
							  <template slot="label">
							    课程主题
							  </template>
							  {{coursedata.theme.title}}
							</el-descriptions-item>
						<!-- 	<el-descriptions-item >
							  <template slot="label">
							    课程类型
							  </template>
							 <el-tag size="small" :color="coursedata.category.color" effect="dark" >{{coursedata.category.title}}</el-tag>
							</el-descriptions-item> -->
							<el-descriptions-item >
							  <template slot="label">
							    课程类型
							  </template>
							 <el-tag size="small" v-for="category in coursedata.category" :key="category" :color="category.color" effect="dark" >{{category.title}}</el-tag>
							</el-descriptions-item>
							<el-descriptions-item >
							  <template slot="label">
							    适用学段
							  </template>
							 <el-tag size="small" v-for="tag in coursedata.periods" :key="tag" :color="tag.color" effect="dark" >{{tag.title}}</el-tag>
							</el-descriptions-item>
						</el-descriptions>
					</div>
				</div>
				<div class="camp_item" :style="screenWidth>785?'':'width:calc(100% - 30px);padding:15px;'" >
					<div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
						<span class="actblock" :style="screenWidth>785?'':'height:30px;'" ></span>营地信息
					</div>
					<div class="campmsg_box" :style="screenWidth>785?'':'width:100%;flex-direction: column;'" @click="gocampdetail(coursedata.camp.id)" >
						<div class="camp_img" :style="screenWidth>785?'':'width:100%;aspect-ratio: 337/161;height:auto;margin:0px;'" >
							<img :src="coursedata.camp.icon" alt="" srcset="">
						</div>
						<div class="camp_msg"  :style="screenWidth>785?'':'width:100%;'" >
							<div class="camp_title">
								{{coursedata.camp.title}}
							</div>
							<div class="camp_phone">
								<i class="el-icon-phone-outline" ></i>
								{{coursedata.camp.phone}}
							</div>
							<div class="camp_address" @click.stop="gomap({latitude:coursedata.camp.latitude,longitude:coursedata.camp.longitude})"> 
								<i class="el-icon-location-information" ></i>
								{{coursedata.camp.address}}
							</div>
						</div>
						
					</div>
					
				</div>
				<div class="coursemain_box">
					<el-tabs v-model="activeName" type="card" >
						<el-tab-pane v-for="(item, index) in coursedata.arr" :key="item" :label="item.title" :name="index">
							<div class="coursemain_richitem" v-for="rich in item.content" :key="rich">
								<div class="rich_title" style="margin-bottom: 10px;">
									<span class="richblock" ></span>{{rich.title}}
								</div>
								<div class="richbox" v-html="rich.content">
									
								</div>
			<!-- 					<div class="coursemain" v-for="content in rich.content"  :key="content">
									{{content}}
								</div> -->
							</div>
							
							
						</el-tab-pane>
					  </el-tabs>
				</div>
		</div>
<!-- 		<div class="swim_box">
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="coursedata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<div :class="tops?'navbar':'navbar-top'"  v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	import {  getNewslist, getPac, getCourselist, getPc,getbottomnav } from '@/request/api'
	
	export default {
	  name: "CourseDetails",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  //搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '资讯搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/traveler',
				  label: '机构搜索'
				},{
				  value: '/mentorlist',
				  label: '指导师搜索'
				},],
				//搜索相关
				manage_url:'',
				manageoptions:[
					{
					  value: 'http://qianjin.wanjiaxiao.cn/',
					  label: '研学报备'
					}, {
					  value: 'https://admin.henanyanxue.com/',
					  label: '管理入口'
					},
					
				],
				activeIndex2: '/CourseDetails',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				banner:[
				],
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				categorytypes:[],
				camptype:0,
				camplist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				category_id:0,
				period:0,
				total:0,
				page_index:1,
				uuid:'',
				coursedata:{},
				activeName:0,
				pcsetdata:{},
				//侧边栏
				 showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					{
						link:'/traveler',
						text:'研学机构'
					},
					{
						link:'/mentorlist',
						text:'研学指导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
          {
            link: '/OrgRegister',
            text: '入驻平台'
          },
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()
	  },
	  mounted() {
		   const { id } = this.$route.query;
		    window.addEventListener('resize', this.handleResize, true)
		   this.uuid = id
		   var token = localStorage.getItem('token')||''
		   this.token=token
		    this.getbottomnav()
			this.getDetails()
			console.log("到这了");
			// this.gettypes()
			
	 window.addEventListener('scroll', this.scrollToTop)
	 		
	 },
	  destroyed () {
	         window.removeEventListener('scroll', this.scrollToTop)
	   },
	 // 销毁监听
	 		beforeDestroy() {
	 		  window.removeEventListener('resize', this.handleResize);
	 		},
	 methods: {
		 gotopsearch(){
		 		  this.$router.push({
		 		    path: this.top_search_url,
		 		    name: this.top_search_url,
		 		    query: {
		 		      stitle: this.stitle,
		 		    }
		 		  }); 
		 },
		 manageurl(e){
		 		  console.log('Site',e)
		 		  if(e!='/'){
		 			   window.open(e) 
		 		  }
		 		//this.manage_url='/'
		 		  // window.location.href = e;
		 		  
		 },
	 		  vanlinkgo(e){
	 		  		  console.log(e)
	 		  		  this.$router.push({
	 		  		    path: e.link,
	 		  		    name: e.link,
	 		  		    query: {
	 		  		    }
	 		  		  }); 
	 		  },
	 		  vannavmenushow(){
	 		  		this.vannavshow=false  
	 		  },
	 		  handleResize() {
	 		  		   this.top_bannerWidth = 0;
	 		    this.screenWidth = window.innerWidth;
	 		  		this.top_bannerWidth=window.innerWidth/3.42
	 		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	 		    this.screenHeight = window.innerHeight;
	 		  },
		 getbottomnav(){
		 		  var data={
		 			  page_index:1,
		 			  page_size:15
		 		  }
		 		getbottomnav(data).then(res=>{
		 			this.bottomnav=res.data.data.list
		 		})  
		 },
		 gobottomnav(type,link){
		 		  if(type==1){
		 			  this.$router.push({
		 			  	path:link
		 			  });
		 		  }else if(type==2){
			  window.location.href = link;
		  }
		 },
		 logout(){
		 			  var that=this
		 			  this.$confirm('是否确认退出登录?', '提示', {
		 			  					confirmButtonText: '确定',
		 			  					cancelButtonText: '取消',
		 			  					type: 'warning'
		 			  }).then(() => {
		 						this.$alert("已退出登录", '', {
		 							confirmButtonText: '确认',
		 							callback: action => {
		 								localStorage.setItem('token', '')
		 								localStorage.setItem('refreshToken', '')
		 								 that.$router.go(0)
		 							}
		 						  });
		 			  }).catch(() => {
		 			  		 
		 			  });
		 },
		 showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		 			  this.showserviceQR=true
		 },
		 hideserviceQRCode(){//隐藏二维码
		     this.showserviceQR = false
		 },
		 showQRCode(){//显示二维码
		         this.showQR = true
		     },
		     hideQRCode(){//隐藏二维码
		         this.showQR = false
		     },
		     scrollToTop () {
		         let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		         this.scrolltop = scrollTop
		         if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		             this.tops = true
		         } else {
		             this.tops = false
		         }
		     },
		     gotop () {
		         let timer = setInterval(() => {
		             document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		             if (this.scrolltop === 0) {
		                 clearInterval(timer)
		             }
		         }, 15)
		     },
		 showphonebox(){
		 		this.phoneboxshow=true  
		 },
		 closephonebox(){
		 		this.phoneboxshow=false  
		 },
		 goregister(e){
		 			  this.$router.push({
		 			    path: "/register",
		 			    name: "/register",
		 			  		  query: {
		 			  		  }
		 			  });
		 },
		 gomap(e) {
		   this.$router.push({
			path: "/Campmap",
			name: "/Campmap",
			query: {
			  latitude:e.latitude,
			  longitude:e.longitude,
			}
		   });
		 },
		 gohome(e) {
		   this.$router.push({
		     path: "/Home",
		     name: "/Home",
		 			  query: {
		 			  }
		   });
		 },
	 		  getpcset(){
	 		  		getPc().then(res=>{
	 		  			this.pcsetdata=res.data.data
	 		  		})  
	 		  },
		  camptypetab(val){
			  this.category_id=val
			  this.getlist()
		  },
		  periodtab(val){
			  this.period=val
			  this.getlist()
		  },
		  pagechange(val){
			this.page_index=val
			this.getlist()
		  },
		  getDetails(){
			var data={
				// type:this.camptype,
				uuid:this.uuid,
			}  
			getCourselist(data).then(res=>{
				console.log(res.data)
				this.coursedata=res.data.data
				const loading = this.$loading({
				         lock: true,
				         text: 'Loading',
				         spinner: 'el-icon-loading',
				         background: 'rgba(0, 0, 0, 0.7)'
				       });
				loading.close();
				// this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			var data={}
			getPac(data).then(res=>{
				console.log(res.data)
				this.categorytypes=res.data.data.cat
				this.periodtypes=res.data.data.res
				// this.category_id=res.data.data.cat[0].id
				// this.getlist()
			}).catch(error => {
			  console.error(error);
			});
		  },
		  /*
		   * 查看详情
		   * */
		  gocampdetail(e) {
		    this.$router.push({
		      path: "/CampDetails",
		      name: "CampDetails",
		      query: {
		        id: e
		      }
		    });
		  },

	  }
	};
</script>

<style scoped>
	.acttop_imgs{
		position: relative;
	}
	.coursemain_richitem{
		padding-bottom: 50px;
	}
	.coursemain{
		padding: 5px 20px;
		font-size: 16px;
		line-height: 24px;
		text-indent: 2rem;
		text-align: left;
	}
	.el-tag--dark{
		border: 0px;
		margin:0px 2px;
	}
	.camp_item{
		padding: 20px;
		margin-top: 20px;
		/* width: 1060px; */
		background: #ffffff;
		
	}
	.campmsg_box{
		display: flex;
		justify-content: space-between;
			align-items: stretch;
	}
	.camp_img{
		width: 337.5px;
		height: 161px;
		margin-left: 30px;
	}
	.camp_img img{
		width: 100%;
		height: 100%;
	}
	.camp_msg{
		width: 660px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	
	}
	.camp_title{
		    font-size: 20px;
		    font-weight: 600;
		    text-align: left;
		    padding: 20px 0px;
	}
	.camp_address{
		color: #1b9d57;
		padding-bottom: 20px;
		    font-size: 16px;
			 text-align: left;
	}
	.camp_phone{
		padding-bottom: 20px;
		color: #66b1ff;
		 text-align: left;
	}
	.moduletitle{
		display: flex;
		align-items: center;
		font-size: 20px;
		margin-bottom: 10px;
	}
	.rich_title{
		padding: 20px;
		padding-bottom: 0px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 18px;
		font-weight: 600;
	}
	.richblock{
		width: 6px;
		height: 30px;
		margin-right: 20px;
		display: block;
		background: #1b9d57;
	}
	.coursemain_box{
		/* padding: 20px; */
		background: #ffffff;
		margin-top: 20px;
	}
	@media only screen and (max-width: 768px){
	::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
	     padding-right: 20px !important;
	 }
	 }
</style>